export const setCurrentContent = (contentName) => {
  return dispatch => {
    dispatch({
      type: 'SET_CURRENT_CONTENT',
      contentName
    });
  };
};



// WEBPACK FOOTER //
// ./src/actions/current-content.js